<template>
    <v-text-field
            v-bind="$props"
            v-on="$listeners"
            type="email"
    >
    </v-text-field>
</template>

<script>
    export default {
        name: "EmailField",
        props: {
            'value': {type: [String, Number]},

            clearable:{type:Boolean, default:false},
            'label': String,
            'prepend-icon': String,
            'append-icon':String,
            'rules': Array,
        },
    }
</script>

<style scoped>

</style>